import { Routes } from '@models/route';
import { lazy } from 'react';

const QuestionnairesListing = lazy(() =>
  import('@pages/questionnaires/QuestionnairesListing').then((p) => ({
    default: p.QuestionnairesListing,
  }))
);

const QuestionnairesDetailsV2 = lazy(() =>
  import('@pages/questionnaires/QuestionnairesDetailsV2').then((p) => ({
    default: p.QuestionnairesDetailsV2WithTabsContext,
  }))
);

export const QuestionnaireRoutes: Routes = [
  {
    path: 'admin/questionnaires',
    component: QuestionnairesListing,
    children: [
      {
        path: 'create',
        component: QuestionnairesDetailsV2,
      },
      {
        path: ':id',
        component: QuestionnairesDetailsV2,
      },
    ],
  },
];
